// libs
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';

// Actions
import actions from '../../actions/notFound';

// Component
import CustomLink from '../tools/customLink/CustomLink';
import Loader from '../tools/loader/Loader';

// Styles
import './NotFound.scss';
import { getHelmetTags, getLoadingHelmetTags } from '../tools/helmetHelpers';

// Props and Context
const propTypes = {
  location: PropTypes.object.isRequired,
  getNotFound: PropTypes.func.isRequired,
  pageData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
};

class NotFound extends Component {
  constructor(props, { customStore, initialRender }) {
    super(props);
    const { location } = this.props;
    if (initialRender) {
      props.getNotFound(customStore);
    }
    this.state = { language: /\/fr/.test(location.pathname) ? 'fr' : 'en' };
  }

  componentDidMount() {
    const { getNotFound, pageData } = this.props;
    const { customStore } = this.context;
    if (Object.keys(pageData).length === 0) {
      getNotFound(customStore);
    }
  }

  render() {
    const { language } = this.state;
    const {
      pageData: {
        title,
        subtitle,
        cta,
        seoData,
      },
      isLoading,
    } = this.props;
    const { t } = this.context;
    if (seoData) {
      seoData.title = t('pages.titles.notFound');
    }
    return (
      <div>
        {isLoading ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData)}
        {isLoading ?
          <Loader loading={isLoading} fullscreen />
          :
          <div className="not-found">
            <h1 className="not-found__title">
              { title || t('pages.titles.notFound')}
            </h1>
            {subtitle &&
            <h2 className="not-found__subtitle">
              { subtitle }
            </h2>
            }
            {cta && cta.title && cta.link.url &&
            <div className="not-found__cta">
              <CustomLink path={cta.link.url} lang={language} className="button button--fill">{cta.title}</CustomLink>
            </div>
            }
            <NavLink className="link link--arrow link--arrow--reverse" to="/fr">{t('pages.notFound.returnToHome')}</NavLink>
          </div>
        }
      </div>
    );
  }
}

NotFound.propTypes = propTypes;
NotFound.contextTypes = contextTypes;

function mapStateToProps(state) {
  return {
    isLoading: state.notFound.isLoading,
    pageData: state.notFound.pageData,
  };
}

export default withRouter(connect(mapStateToProps, actions)(NotFound));



// WEBPACK FOOTER //
// ./src/app/components/pages/NotFound.js